import React, { useCallback } from 'react';

import { useMenuContext } from 'components/shared/menu';
import Slot from 'components/shared/Slot';

export type MenuTriggerProps = React.HTMLAttributes<HTMLElement> & {
  disabled?: boolean;
};

// As of React 19, any HTML element or React component passed in as the direct child will automatically inherit the ref prop
export default function MenuTrigger({ disabled = false, ...props }: MenuTriggerProps) {
  const { toggle, triggerRef } = useMenuContext();

  const handleClick = useCallback(() => {
    if (disabled) return;
    toggle();
  }, [disabled, toggle]);

  return <Slot onClick={handleClick} {...props} {...(triggerRef ? { ref: triggerRef } : {})} />;
}
